export function isIosDevice(): boolean {
  if (typeof navigator === 'undefined') return false
  const ua = navigator.userAgent
  const isIphoneOrIpad = /iPhone|iPad|iPod/.test(ua)
  // iPadOS 13+ はデスクトップの UA を名乗るがタッチ入力は持つため、maxTouchPoints で検出する。
  const isIpadOs =
    navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1
  return isIphoneOrIpad || isIpadOs
}

export function isStandalone(): boolean {
  if (typeof window === 'undefined') return false
  const matchesStandalone =
    typeof window.matchMedia === 'function' &&
    window.matchMedia('(display-mode: standalone)').matches
  // navigator.standalone は iOS 限定の非標準フラグ。
  const navigatorStandalone = (
    navigator as Navigator & { standalone?: boolean }
  ).standalone
  return matchesStandalone || navigatorStandalone === true
}
